import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var TextJustifier = /** @class */ (function (_super) {
    __extends(TextJustifier, _super);
    function TextJustifier(locale, lineJustification) {
        var _this = _super.call(this) || this;
        _this._locale = axCoerceString(locale);
        _this._lineJustification = axCoerceString(lineJustification);
        return _this;
    }
    TextJustifier.getJustifierForLocale = function (locale) {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextJustifier', 'getJustifierForLocale', '');
        return null;
    };
    TextJustifier.prototype.clone = function () {
        // @todo
        Debug.throwPIR('playerglobals/text/engine/TextJustifier', 'clone', '');
        return null;
    };
    Object.defineProperty(TextJustifier.prototype, "locale", {
        get: function () {
            return this._locale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextJustifier.prototype, "lineJustification", {
        get: function () {
            return this._lineJustification;
        },
        set: function (value) {
            this._lineJustification = axCoerceString(value);
        },
        enumerable: false,
        configurable: true
    });
    TextJustifier.prototype.setLocale = function (value) {
        this._locale = axCoerceString(value);
    };
    TextJustifier.forceNativeConstructor = true;
    TextJustifier.forceNativeMethods = true;
    return TextJustifier;
}(ASObject));
export { TextJustifier };
